import { useQuery } from "@tanstack/react-query";

import { getProjectsProjectID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "./queryKeys";

export function useProjectDetailQuery(projectId: string) {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEYS.detail(projectId),
    queryFn: processResponse(() => getProjectsProjectID(projectId)),
    enabled: !!projectId,
  });
}
